{
  "steps": {
    "usage":            "What will you use Khronox for?",
    "manage":           "What would you like to manage?",
    "orgName":          "What would you like to call your first organization?",
    "features":         "What features would you like to try?",
    "taskOrganization": "How do you want to organize your tasks?",
    "inviteMembers":    "Invite collaborators to your organization:"
  },
  "usage": {
    "personal":  "Personal use",
    "team":      "Small team",
    "company":   "Company",
    "freelance": "Freelance"
  },
  "manage": {
    "projects": "Projects",
    "tasks":    "Tasks",
    "team":     "Team",
    "clients":  "Clients"
  },
  "features": {
    "tasks":       "Tasks & projects",
    "automations": "Automations",
    "goals":       "Goals",
    "chat":        "Chat",
    "sprints":     "Sprints",
    "docs":        "Documents",
    "calendar":    "Calendar",
    "crm":         "CRM",
    "gantt":       "Timelines",
    "flowchart":   "Flow diagrams",
    "time":        "Time tracking",
    "forms":       "Forms",
    "workload":    "Workload",
    "ai":          "AI"
  },
  "taskOrganization": {
    "board":    "Kanban board",
    "list":     "List",
    "calendar": "Calendar",
    "gantt":    "Gantt"
  },
  "navigation": {
    "back":   "Back",
    "next":   "Next",
    "finish": "Finish",
    "skip":   "Skip",
    "saving": "Saving..."
  },
  "invite": {
    "placeholder": "Type or paste email addresses",
    "hint":        "Press Enter or comma to add multiple emails",
    "remove":      "Remove {{email}}",
    "errors": {
      "invalid":   "Enter a valid email address",
      "duplicate": "This email has already been added"
    }
  },
  "orgName": {
    "placeholder": "Organization name"
  },
  "title":   "Initial organization setup",
  "welcome": "Welcome to Khronox, {{name}}!",
  "error":   "Something went wrong. Please try again."
}